exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-b38ed852] {\n  background: rgba(0, 0, 0, 0.25);\n  display: block;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.3s;\n}\n.modal .modal-dialog[data-v-b38ed852] {\n  transform: translateY(-80px);\n  transition: all 0.3s;\n}\n.modal.show[data-v-b38ed852] {\n  visibility: visible;\n  opacity: 1;\n}\n.modal.show .modal-dialog[data-v-b38ed852] {\n  transform: translateY(0);\n}", ""]);

// exports
